export const DCIS = "/ph/ms1/api/dci/all?withpagination=true&active=1"
export const DCI_CREATE = "/api/ADD_DCI"
export const DCI = "/ph/ms1/api/dci/all?withpagination=false&active=1&id=:param"
export const DCI_ACTIVATE = "/api/DCI/:param/activate"
export const DCI_DEACTIVATE = "/api/DCI/:param/deactivate"
export const DCI_DELETE = "/api/dci/:param/delete"

export const EXPORT_DCI = "/api/dcis/export"
export const IMPORT_DCI = "/api/dci/import"

export const SPECIALITY_DCI = "/ph/ms1/api/specialite/all"
export const GET_SPECIALITY_DCI = "/ph/ms1/api/specialite/all?withpagination=false&dci=:param"
export const FILTER_SPECIALITY_DCI = "/ph/ms1/api/specialite/all"
